import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Pfooter from '../Pfooter';
import LoginHeader from './LoginHeader';
import { userActions } from '../store/user-slice';
import { clearSelectedClient } from '../ClientSelection';
import '../App.css';
import './Login.css';

/**
 * "Login As" chooser - /Login/Customer and /Login/Company.
 *
 * The home page's Login As menu lands here instead of going straight to one
 * login, so a person can always pick the branch - even while already signed
 * in to the other one. Each card shows whether that branch is signed in, and
 * offers Continue / Log out, or Sign in.
 *
 * The two branches keep completely separate sessions: the normal portal uses
 * the plain keys, the Shimoga portal (src/shimoga) uses "shimoga:" keys. This
 * page only READS them, and Log out clears one branch's keys only.
 */

const SHIMOGA = 'shimoga:';

const read = (key) => {
    try {
        return JSON.parse(window.localStorage.getItem(key));
    } catch (e) {
        return null;
    }
};
const readRaw = (key) => {
    try {
        return window.localStorage.getItem(key);
    } catch (e) {
        return null;
    }
};

// Who is signed in to a branch: { name, place, as: 'Cust' | 'Com' } or null
const sessionOf = (prefix) => {
    const user = read(prefix + 'user-info');
    if (!user || !user.token) return null;
    return {
        name: user.name || user.userName || '',
        place: user.place || '',
        as: (readRaw(prefix + 'app-type') || 'Cust').replace(/"/g, ''),
    };
};

const BRANCHES = [
    {
        key: 'main',
        prefix: '',
        title: 'UDUPI HEAD BRANCH',
        firms: 'Sarvodaya Agencies Udupi · Vetrem Pharma',
        base: '',
    },
    {
        key: 'shimoga',
        prefix: SHIMOGA,
        title: 'SHIMOGA BRANCH',
        firms: 'Sarvodaya Agencies, Shimoga',
        base: '/Shimoga',
    },
];

const dashboardOf = (base, as) =>
    base +
    (as === 'Com'
        ? '/components/company/CompanyDashboard'
        : '/components/customer/CustomerDashboard');

export default function LoginChooser() {
    const history = useHistory();
    const dispatch = useDispatch();
    const { type } = useParams();
    const who = type === 'Company' ? 'Company' : 'Customer';
    const [, refresh] = useState(0);

    const logout = (b) => {
        if (b.key === 'shimoga') {
            Object.keys(window.localStorage)
                .filter((k) => k.startsWith(SHIMOGA))
                .forEach((k) => window.localStorage.removeItem(k));
            // the Shimoga screens may be loaded in this tab - start them fresh
            window.location.reload();
            return;
        }
        ['user-info', 'user-id', 'app-type', 'report-firm'].forEach((k) =>
            window.localStorage.removeItem(k)
        );
        clearSelectedClient();
        dispatch(userActions.setLogin(false));
        refresh((n) => n + 1);
    };

    return (
        <div className='loginShell'>
            <LoginHeader />

            <div className='loginPage'>
                <div className='chooserWrap'>
                    <h2 className='chooserTitle'>{who} Login</h2>
                    <p className='chooserSub'>Choose your branch</p>

                    <div className='chooserGrid'>
                        {BRANCHES.map((b) => {
                            const s = sessionOf(b.prefix);
                            // signed in to this branch, but on the OTHER side
                            // (customer vs company) from the login chosen
                            const want = who === 'Company' ? 'Com' : 'Cust';
                            const otherSide = s && s.as !== want;
                            return (
                                <section
                                    key={b.key}
                                    className={'chooserCard' + (b.key === 'shimoga' ? ' chooserShimoga' : '')}
                                >
                                    <header className='chooserHead'>
                                        <h3 className='chooserBranch'>{b.title}</h3>
                                        <p className='chooserFirms'>{b.firms}</p>
                                    </header>

                                    <div className='chooserBody'>
                                        {s ? (
                                            <p className='chooserStatus'>
                                                <span className='chooserOn'>
                                                    SIGNED IN AS {s.as === 'Com' ? 'COMPANY' : 'CUSTOMER'}
                                                </span>
                                                <br />
                                                <b>{s.name || 'Signed in'}</b>
                                                {s.place ? ', ' + s.place : ''}
                                            </p>
                                        ) : (
                                            <p className='chooserStatus'>Not signed in</p>
                                        )}

                                        <div className='chooserActions'>
                                            {s && otherSide ? (
                                                <>
                                                    {/* asked for the other side: offer that login,
                                                        not a Continue into this one */}
                                                    <button
                                                        type='button'
                                                        className='chooserBtn'
                                                        onClick={() => history.push(b.base + '/' + who)}
                                                    >
                                                        Sign in as {who.toLowerCase()}
                                                    </button>
                                                    <button
                                                        type='button'
                                                        className='chooserBtn chooserBtnGhost'
                                                        onClick={() => history.push(dashboardOf(b.base, s.as))}
                                                    >
                                                        Back to {s.as === 'Com' ? 'company' : 'customer'}
                                                    </button>
                                                </>
                                            ) : s ? (
                                                <>
                                                    <button
                                                        type='button'
                                                        className='chooserBtn'
                                                        onClick={() => history.push(dashboardOf(b.base, s.as))}
                                                    >
                                                        Continue
                                                    </button>
                                                    <button
                                                        type='button'
                                                        className='chooserBtn chooserBtnGhost'
                                                        onClick={() => logout(b)}
                                                    >
                                                        Log out
                                                    </button>
                                                </>
                                            ) : (
                                                <button
                                                    type='button'
                                                    className='chooserBtn'
                                                    onClick={() => history.push(b.base + '/' + who)}
                                                >
                                                    Sign in
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </section>
                            );
                        })}
                    </div>
                </div>
            </div>

            <Pfooter />
        </div>
    );
}
